module.exports = __webpack_public_path__ + "static/img/1_1.f6596c4d.jpg";